module.exports = __webpack_public_path__ + "img/icons8-spotify-fluent.050675ad.svg";